<div class="card" style="height: calc(100% - 28px);">
  <div class="card-header d-flex justify-content-between pb-0">
    <span class="card-title h4 text-primary">{{ title }}</span>
  </div>
  <div class="card-body">
    <div class="row flex-wrap h-100 align-items-center">
      <div class="d-flex flex-column mt-1 col-lg-7 col-md-8 col-12" style="max-height: 360px; overflow-y: auto">
        <div class="mr-1 ml-1" *ngFor="let count of counts">
          <p class="card-text mb-50 font-weight-bold">{{ count.title }}</p>
          <span class="font-large-1 font-weight-bold">{{ count.count }}</span>
          <ng-container *ngIf="count.team">
            <p *ngFor="let t of count.team" class="text-right">
              {{ t.name }}
            </p>
          </ng-container>
          <ng-container *ngIf="count.text">
            <p *ngFor="let t of count.text" class="text-right">
              {{ t }}
            </p>
          </ng-container>
          <hr />
        </div>
      </div>
      <div class="col-lg-5 col-md-4 col-12 d-flex justify-content-center" #chartRef>
        <div id="chartOptions1">
          <!-- Apexchart component-->
          <apx-chart [series]="chartOptions1.series" [chart]="{
              height: 400,
              width:
                isMenuToggled === false
                  ? chartRef.offsetWidth
                  : chartOptions1.chart.width,
              type: 'bar',
              toolbar: {
                show: false
              }
            }" [dataLabels]="chartOptions1.dataLabels" [plotOptions]="chartOptions1.plotOptions"
            [xaxis]="chartOptions1.xaxis" [colors]="chartOptions1.colors" [grid]="chartOptions1.grid"></apx-chart>
          <!-- / Apexchart component-->
        </div>
      </div>
    </div>
  </div>
</div>